'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// /home/circleci/project/node_modules/swagger-client/node_modules/js-yaml/index.js
// module id = 1378
// module chunks = 0